import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {Extract<import('mdast').Root|import('mdast').Content, import('unist').Parent>} Parent
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */
import { listItem } from 'mdast-util-to-markdown/lib/handle/list-item.js';
import { track } from 'mdast-util-to-markdown/lib/util/track.js';
/** @type {FromMarkdownExtension} */

export var gfmTaskListItemFromMarkdown = {
  exit: {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
  }
};
/** @type {ToMarkdownExtension} */

export var gfmTaskListItemToMarkdown = {
  unsafe: [{
    atBreak: true,
    character: '-',
    after: '[:|-]'
  }],
  handlers: {
    listItem: listItemWithTaskListItem
  }
};
/** @type {FromMarkdownHandle} */

function exitCheck(token) {
  var node =
  /** @type {ListItem} */
  this.stack[this.stack.length - 2]; // We’re always in a paragraph, in a list item.

  node.checked = token.type === 'taskListCheckValueChecked';
}
/** @type {FromMarkdownHandle} */


function exitParagraphWithTaskListItem(token) {
  var parent =
  /** @type {Parent} */
  this.stack[this.stack.length - 2];
  var node =
  /** @type {Paragraph} */
  this.stack[this.stack.length - 1];
  var siblings = parent.children;
  var head = node.children[0];
  var index = -1;
  /** @type {Paragraph|undefined} */

  var firstParaghraph;

  if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean' && head && head.type === 'text') {
    while (++index < siblings.length) {
      var sibling = siblings[index];

      if (sibling.type === 'paragraph') {
        firstParaghraph = sibling;
        break;
      }
    }

    if (firstParaghraph === node) {
      // Must start with a space or a tab.
      head.value = head.value.slice(1);

      if (head.value.length === 0) {
        node.children.shift();
      } else if (node.position && head.position && typeof head.position.start.offset === 'number') {
        head.position.start.column++;
        head.position.start.offset++;
        node.position.start = Object.assign({}, head.position.start);
      }
    }
  }

  this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */


function listItemWithTaskListItem(node, parent, context, safeOptions) {
  var head = node.children[0];
  var checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
  var checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
  var tracker = track(safeOptions);

  if (checkable) {
    tracker.move(checkbox);
  }

  var value = listItem(node, parent, context, _objectSpread(_objectSpread({}, safeOptions), tracker.current()));

  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
  }

  return value;
  /**
   * @param {string} $0
   * @returns {string}
   */

  function check($0) {
    return $0 + checkbox;
  }
}